export default "__VITE_ASSET__e201aa37__"